import { render, staticRenderFns } from "./EditReview.vue?vue&type=template&id=15e74571&"
import script from "./EditReview.vue?vue&type=script&lang=js&"
export * from "./EditReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports